import { useMemo } from "react";
import { marketOverview } from "../../core/data/marketOverview";

// marketOverview() for the report data loaded by useReportData, recomputed
// whenever the data or filters change - never a new fetch.
export default function useMarketOverview(data, filters) {
  // Filters arrive as a new object each render; compare by content.
  const filtersKey = JSON.stringify(filters || {});
  return useMemo(
    () => (data && data.job ? marketOverview(data, JSON.parse(filtersKey)) : null),
    [data, filtersKey]
  );
}
